const $ = window.jQuery;
const Hammer = window.Hammer;
const isDesktop = window.matchMedia("(min-width: 768px)");
const getEventConfig = window.getEventConfig;
const config = getEventConfig();

/**
 * Time constants
 * @type {Object}
 */
const TIME = {
	FADE: {
		DEFAULT: 300,
		SHORT: 100,
	},
	THROTTLE: 100,
	DEBOUNCE: 100,
};

export function addVoidForLinks(links) {
	$.each(links, (index, element) => {
		const link = $(element);
		if (link.attr(`href`) === `` || link.attr(`href`) === `#`) {
			link.attr(`href`, `javascript:void(0)`);
		}
	});
}

// a11y hamburger https://foxland.fi/simple-accessible-svg-menu-hamburger-animation
export function hamburger(element) {
	const button = document.getElementById(element);

	if (!button) {
		return false;
	}
	let scrollPosition = 0;
	button.onclick = () => {
		if (button.className.indexOf("opened") !== -1) {
			document.querySelector("body").scrollTo({
				top: scrollPosition,
				behavior: "smooth",
			});
			button.className = button.className.replace(" opened", "");
			button.setAttribute("aria-expanded", "false");
			document.querySelector(`.body`).classList.remove(`body_overlay`);
		} else {
			scrollPosition = $("body")[0].scrollTop;
			document.querySelector("body").scrollTo({
				top: 0,
				behavior: "smooth",
			});
			button.className += " opened";
			button.setAttribute("aria-expanded", "true");
			document.querySelector(`.body`).classList.add(`body_overlay`);
			$(".js-search-form").slideUp("fast");
			$(".js-header-logout").prependTo(".header__links");
			$(".menu").prependTo(".header__right");
			$(".js-header-login").prependTo(".js-header-top");
			$(".header__hover").insertAfter(".dropdown_header");
			$(".header__link_profile").insertAfter(".header__center");
		}
	};

	return false;
}

export function getRequest(url, data = null, type = "GET", parse = true, needOverlay = true) {
	return new Promise((succeed, fail) => {
		$.ajax({
			url,
			data,
			context: this,
			type,
			beforeSend: () => {
				if (needOverlay) {
					$("#js-overlay").show();
				}
			},
			success: response => {
				if (parse) {
					succeed(JSON.parse(response));
				} else {
					succeed(response);
				}
			},
			complete: () => {
				$("#js-overlay").hide();
			},
			error: error => {
				fail(new Error(`Request failed: ${error}`));
			},
		});
	});
}

export function insertDataToTicket(item, isPack = false) {
	const sector = item.sector || item.view_id;
	let price;

	if (item.price>=0) {
		price = item.price;
	} else {
		price = "";
	}

	const name = isPack ? "" : `Ряд ${item.row} место ${item.col}`;

	return `<div class="tickets__item js-ticket-template" data-place="${item.sid}" data-uid="${item.uid}" data-ispack="${isPack}">
				<div class="tickets__content">
					<div class="tickets__sector">${sector}</div>
					<span class="tickets__place">
						<span class="js-ticket-place">${name}</span>
						<strong class="tickets__place-price">
							<span class="js-ticket-price">${price}</span> руб.
						</strong>
					</span>
					<div class="tickets__remove js-tickets-remove">
						<button class="tickets__remove-button"  type="button" data-selenium="event_seat_delete">Удалить</button>
					</div>
				</div>
			</div>`;
}

export function setObjectToSessionStorage(name, object) {
	sessionStorage.setItem(name, JSON.stringify(object));
}

export function getObjectFromSessionStorage(name) {
	if (sessionStorage.getItem(name)) {
		return JSON.parse(sessionStorage.getItem(name));
	}
	return false;
}

export function setTransformForTickets() {
	const parent = $(".tickets_subscription");
	const tickets = parent.find(".tickets__item");
	if (!tickets.length) {
		return false;
	}

	const width = parent.width();
	const length = tickets.length;
	let size = 0;
	let gap = 0;
	const optimalWidth = width / length;
	$.each(tickets, (i, item) => {
		const element = $(item);
		const elementWidth = element.width() + 20;
		gap = elementWidth - optimalWidth;
		if (gap < 75) {
			gap = 75;
		}
		let minus = "";
		if (size > 0) {
			minus = "-";
		}
		element.css("transform", `translateX(${minus}${size}px)`);
		size += gap;
	});
}

/**
 * Function to throttle the execution of event handlers
 * @param  {Function} callback
 * @param  {Number|undefined} delay
 * @return {Function}
 */
export function throttle(callback, delay) {
	console.log(4);
	let hold = false;
	delay = delay || TIME.THROTTLE;

	return function handleEvent(...args) {
		if (hold) return;

		hold = true;
		callback.apply(this, args);

		window.setTimeout(() => {
			hold = false;
		}, delay);
	};
}

export function viewPromoButton() {
	const promo = $(".js-promo");
	$.each(promo, (index, element) => {
		const promoInput = $(element).find(".promo__input");
		promoInput.on("keypress", () => {
			$(element).addClass("active");
		});

		promoInput.on("input", () => {
			$(element).addClass("active");
		});

		promoInput.on("focus", () => {
			$(element).addClass("focus");
		});

		promoInput.on("blur", () => {
			$(element)
				.removeClass("active")
				.removeClass("focus");

			if (promoInput.val()) {
				$(element)
					.addClass("active")
					.removeClass("focus");
			}
		});
	});
}

export const hammerEventsHandler = {
	haltEventListeners: ["touchstart", "touchend", "touchmove", "touchleave", "touchcancel"],
	init(options) {
		const instance = options.instance;
		let initialScale = 1;
		let pannedX = 0;
		let pannedY = 0;
		// Init Hammer
		// Listen only for pointer and touch events
		this.hammer = Hammer(options.svgElement, {
			inputClass: Hammer.SUPPORT_POINTER_EVENTS
				? Hammer.PointerEventInput
				: Hammer.TouchInput,
		});
		// Enable pinch
		this.hammer.get("pinch").set({ enable: true });
		// Handle double tap
		this.hammer.on("doubletap", () => {
			instance.zoomIn();
		});
		// Handle pan
		this.hammer.on("panstart panmove", ev => {
			// On pan start reset panned variables
			if (ev.type === "panstart") {
				pannedX = 0;
				pannedY = 0;
			}
			// Pan only the difference
			instance.panBy({ x: ev.deltaX - pannedX, y: ev.deltaY - pannedY });
			pannedX = ev.deltaX;
			pannedY = ev.deltaY;
		});
		// Handle pinch
		this.hammer.on("pinchstart pinchmove", ev => {
			// On pinch start remember initial zoom
			if (ev.type === "pinchstart") {
				initialScale = instance.getZoom();
				instance.zoomAtPoint(initialScale * ev.scale, { x: ev.center.x, y: ev.center.y });
			}
			instance.zoomAtPoint(initialScale * ev.scale, { x: ev.center.x, y: ev.center.y });
		});
		// Prevent moving the page on some devices when panning over SVG
		options.svgElement.addEventListener("touchmove", e => {
			e.preventDefault();
		});
	},
	destroy() {
		this.hammer.destroy();
	},
};

export function convertToServerDate(timestamp) {
	const date = new Date(timestamp);
	return `${`0${date.getDate()}`.substr(-2, 2)}-${date.getMonth() +
		1}-${`${date.getFullYear()}`.substr(-2, 2)}`;
}

export function menuOnMobile() {
	$(".js-menu-next").on("click", e => {
		const element = $(e.currentTarget);
		const menuList = element.parents(".js-menu").find(".js-menu-list");
		const items = menuList.find(".js-menu-item");
		const currentPosition = menuList[0].scrollLeft;
		$.each(items, (index, el) => {
			const item = $(el);
			const itemPosition =
				item[0].getBoundingClientRect().x || item[0].getBoundingClientRect().left;
			if (itemPosition > currentPosition) {
				const itemWidth = item[0].getBoundingClientRect().width;
				menuList[0].scrollLeft = itemPosition + itemWidth + 30;
				return false;
			}
			menuList[0].scrollLeft = menuList[0].getBoundingClientRect().width;
			return true;
		});
	});
}

export function convertStringToObject(str) {
	const properties = str.split(",");
	const obj = {};
	properties.forEach(property => {
		const tup = property.split(":");
		obj[tup[0]] = tup[1];
	});
	return obj;
}

export function profileSubmenu() {
	const link = document.querySelector(".header__link_profile");

	if (isDesktop.matches && link) {
		if (link.nextElementSibling) {
			const parentLink = document.querySelector(".header__auth");
			link.addEventListener("focus", () => {
				parentLink.classList.add("focus");
			});
			link.addEventListener("blur", () => {
				parentLink.classList.remove("focus");
			});

			const subMenu = document.querySelector(".header__hover");
			const subMenuLinks = subMenu.querySelectorAll("a");
			const lastLinkIndex = subMenuLinks.length - 1;
			const lastLink = subMenuLinks[lastLinkIndex];

			lastLink.addEventListener("blur", () => {
				link.parentElement.classList.remove("focus");
			});
		}
	}
}

/**
 * Возвращает значения зоны для получения цен и цвета
 * @param {Number} zoneId - Номер зоны
 * @param {Array} zones - Список зон
 * @return {Object}
 */
export function getZonePropertiesById(zoneId, zones) {
	return zones.filter(element => element.zone === zoneId)[0];
}

export function insertEventsToSearchResults(event) {
	return `
		<div class="search-result__item">
		<div class="search-result__name">${event.name}</div>
<a href="/event?id=${event.eventId}" class="btn">Купить билет</a>
		</div>
	`;
}

/*
 * @param number n
 * @param array forms
 * @return string
 * WordEnding(42, ['арбуз', 'арбуза', 'арбузов']);
 * 42 арбуза
 */
export function wordEnding(n, textForms) {
	n = Math.abs(n) % 100;
	let n1 = n % 10;
	if (n > 10 && n < 20) {
		return textForms[2];
	}
	if (n1 > 1 && n1 < 5) {
		return textForms[1];
	}
	if (n1 === 1) {
		return textForms[0];
	}
	return textForms[2];
}

export function toTop() {
	const eventItems = $(".subscription__items");

	if (!eventItems.length) {
		return false;
	}

	const eventTop = $(".js-to-top");
	let needCorrect = 150;

	const top = eventItems.offset().top - needCorrect;

	eventTop.on("click", () => {
		$("body")[0].scrollTo({
			top,
			behavior: "smooth",
		});

		eventTop.removeClass("active");
	});

	$("body").on("scroll", () => {
		if (top + 100 <= $("body").scrollTop()) {
			eventTop.addClass("active");
		} else {
			eventTop.removeClass("active");
		}
	});
}
